"use client";

import PhoneInputLib, { getCountries, type Value } from "react-phone-number-input";
import type { Country } from "react-phone-number-input";
import "react-phone-number-input/style.css";

export type { Value, Country };

// Pays exclus du sélecteur (pas de relations avec l'Algérie).
const EXCLUDED_COUNTRIES: Country[] = ["IL" as Country];
const AVAILABLE_COUNTRIES = getCountries().filter((c) => !EXCLUDED_COUNTRIES.includes(c));

interface PhoneInputProps {
  value?: Value;
  onChange: (value?: Value) => void;
  onCountryChange?: (country?: Country) => void;
  defaultCountry?: Country;
  placeholder?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
}

/**
 * Phone number field built on `react-phone-number-input`.
 * Renders a country/flag selector + a number input, returning an E.164 value.
 */
export function PhoneInput({ className = "", defaultCountry = "DZ" as Country, ...props }: PhoneInputProps) {
  return (
    <PhoneInputLib
      international
      countries={AVAILABLE_COUNTRIES}
      defaultCountry={defaultCountry}
      countryCallingCodeEditable={false}
      className={`fast-phone-input ${className}`}
      {...props}
    />
  );
}
